import Vue from "vue";
import Router from "vue-router";
import Store from "./store";
import Home from "./views/Home.vue";
import Product from "./views/Product.vue";
import Shoppinglist from "./views/Shoppinglist.vue";
import Print from "./views/Print.vue";
import Preview from "./views/Preview.vue";
import NotFound from "./views/NotFound.vue";

import config from "@/config";

const isActiveSale = config.isActiveSale();
const isEndedSale = config.isEndedSale();

Vue.use(Router);
let thisRoutes = [];

if (!isActiveSale) {
  thisRoutes = [
    {
      path: "*",
      name: "preview",
      component: Preview,
      meta: { preview: true, hint: isEndedSale },
    },
  ];
} else {
  thisRoutes = [
    {
      path: "/",
      name: "home",
      meta: { type: "home" },
      component: Home,
      beforeEnter: (to, from, next) => {
        if (
          Store.state.market &&
          Store.state.market.nr &&
          Store.state.market.slug
        ) {
          next({
            replace: true,
            name: "homeMarket",
            params: {
              nr: Store.state.market.nr,
              slug: Store.state.market.slug,
              jump: to.params.jump,
            },
          });
        } else {
          next();
        }
      },
    },
    {
      path: "/markt/:nr/:slug",
      name: "homeMarket",
      meta: { type: "home" },
      component: Home,
    },
    {
      path: "/produkt/:nr/:slug",
      name: "product",
      component: Product,
    },
    {
      path: "/liste/:key",
      name: "shoppinglist",
      component: Shoppinglist,
    },
    {
      path: "/printliste/:key",
      name: "print",
      component: Print,
    },
    {
      path: "/preview",
      name: "previewThis",
      component: Preview,
      meta: { preview: true, hint: false },
    },
    {
      path: "/previewHint",
      name: "previewHint",
      component: Preview,
      meta: { preview: true, hint: true },
    },
    {
      path: "/previewNext",
      name: "previewNext",
      component: Preview,
      meta: { preview: true, hint: false },
    },
    {
      path: "*",
      name: "notfound",
      component: NotFound,
    },
  ];
}

const thisRouterConfig = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: thisRoutes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
};

const thisRouter = new Router(thisRouterConfig);

thisRouter.beforeEach((to, from, next) => {
  Store.commit("SET_SHOW_SHOPPINGLIST", false);

  next();
});

export default thisRouter;
